export default __webpack_public_path__ + "static/media/sala-pietra-outside-2.eba1b178.jpg";